import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/login/error.png';
import _imports_1 from '../../assets/images/login/warning.png';
import _imports_2 from '../../assets/images/login/error.png';
const _withScopeId = n => (_pushScopeId("data-v-4bcf481f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "yzm-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "验证码登录", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "未注册用户登录将自动注册", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " +86 ", -1));
const _hoisted_5 = {
  key: 0,
  classs: "phoneerror",
  style: {
    "padding-right": "15px",
    "display": "flex",
    "align-items": "center",
    "color": "#fd5555"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "16",
  height: "16",
  alt: "",
  style: {
    "margin-right": "3px"
  }
}, null, -1));
const _hoisted_7 = {
  class: "yzm"
};
const _hoisted_8 = {
  key: 1,
  class: "big send_code"
};
const _hoisted_9 = {
  style: {
    "color": "#006eff"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {
    "color": "#9d9ca3"
  }
}, " 后重新获取 ", -1));
const _hoisted_11 = {
  class: "xy"
};
const _hoisted_12 = {
  class: "errorbox"
};
const _hoisted_13 = {
  key: 0,
  src: _imports_1
};
const _hoisted_14 = {
  key: 1,
  src: _imports_2
};
const _hoisted_15 = {
  class: "yzm_bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_el_input, {
    class: _normalizeClass(["input", {
      input_error: _ctx.isError
    }]),
    modelValue: _ctx.phone,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.phone = $event),
    placeholder: "请输入有效手机号",
    onBlur: _ctx.phoneBlur
  }, {
    prepend: _withCtx(() => [_hoisted_4]),
    suffix: _withCtx(() => [_ctx.isError ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createTextVNode("手机号错误 ")])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onBlur", "class"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
    class: _normalizeClass(["input", {
      input_error: _ctx.errorCode
    }]),
    style: {
      "width": "250px"
    },
    modelValue: _ctx.code,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.code = $event),
    placeholder: "请输入验证码"
  }, null, 8, ["modelValue", "class"]), _ctx.timeOver ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.getCode && _ctx.getCode(...args)),
    class: _normalizeClass(["big send_code", {
      send_code_dis: !_ctx.phone || _ctx.isError
    }])
  }, " 获取验证码 ", 2)) : _createCommentVNode("", true), !_ctx.timeOver ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.time) + "S", 1), _hoisted_10])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_checkbox, {
    style: {
      "margin-right": "4px"
    },
    modelValue: _ctx.checked,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.checked = $event)
  }, null, 8, ["modelValue"]), _createTextVNode(" 已阅读并同意 "), _createVNode(_component_router_link, {
    to: {
      path: '/'
    },
    class: _normalizeClass({
      ischeck: _ctx.checked
    }),
    style: {
      "padding": "0 2px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(" 《服务协议》 ")]),
    _: 1
  }, 8, ["class"]), _createTextVNode(" 和 "), _createVNode(_component_router_link, {
    to: {
      path: '/'
    },
    class: _normalizeClass({
      ischeck: _ctx.checked
    }),
    style: {
      "padding": "0 2px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(" 《隐私协议》 ")]),
    _: 1
  }, 8, ["class"])]), _createElementVNode("div", _hoisted_12, [_ctx.error || _ctx.warning ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["lip", {
      error: _ctx.error,
      warning: _ctx.warning
    }])
  }, [_ctx.warning ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true), _ctx.error ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: _normalizeClass(["login", {
      'no-click': !_ctx.phone || _ctx.isError || !_ctx.code.trim()
    }]),
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.login && _ctx.login(...args))
  }, " 登 录 ", 2), _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_vShow, _ctx.showBottomLogo]])]);
}